"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormatter = void 0;
const numberFormatter = (currency, value, simplify) => {
    const has_decimal_places = value % 1 !== 0;
    let formattedValue;
    switch (currency) {
        case "JPY":
            if (simplify) {
                formattedValue = value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    useGrouping: false,
                });
            }
            else {
                formattedValue = value.toLocaleString("en-US", {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                    useGrouping: false,
                });
            }
            break;
        case "THB":
            formattedValue = value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                useGrouping: false,
            });
            break;
        case "AED":
        case "SGD":
        case "MYR":
        case "USD":
        case "CNY":
        case "AUD":
        case "CAD":
        case "EUR":
        case "HKD":
        case "SAR":
        case "NZD":
        case "DKK":
        case "PHP":
        case "NOK":
        case "ZAR":
        case "SEK":
        case "GBP":
        case "CHF":
            formattedValue = value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
                useGrouping: false,
            });
            break;
        case "IDR":
        case "VND":
            if (simplify) {
                formattedValue = value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    useGrouping: false,
                });
            }
            else {
                formattedValue = value.toLocaleString("en-US", {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                    useGrouping: false,
                });
            }
            break;
        case "INR":
        case "TWD":
        case "KRW":
            formattedValue = value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                useGrouping: false,
            });
            break;
        default:
            formattedValue = value.toString();
    }
    return parseFloat(formattedValue);
};
exports.numberFormatter = numberFormatter;
